import React, { useCallback, useEffect, useRef, useState } from 'react'

import { FaArrowRotateLeft } from 'react-icons/fa6'
import { LuArrowUpDown }     from 'react-icons/lu'
import { FaCheck }           from 'react-icons/fa6'

import Select from '@/Form/V2/Select'

import { budget_options } from '@Config/options'

import bemit from '@function/bemit'

import FormsStore from '@Store/Forms'

const FORM_NAME = 'ECRenewal';

const available_options = budget_options
.filter(opt => opt.value && opt.value !== 'none');

export default function ECRenewalBudgetChange ({ onChange, ...props })
{
	const EC_budget = props['default-budget'] || 'none';

	const [editing, setEditing] = useState(false);

	const [new_value, setNewValue] = useState(EC_budget);

	const _refs = useRef();

	useEffect(function ()
	{
		setNewValue(EC_budget);

		FormsStore.update(function (store)
		{
			store[FORM_NAME] ||= { };

			store[FORM_NAME].EC_budget = EC_budget;
		});

		console.log('EC_budget change', EC_budget);
	},
	[EC_budget]);

	useEffect(function ()
	{
		_refs.current = { onChange };
	},
	[onChange]);

	const startEditing = useCallback(function (e)
	{
		setEditing(true);
	},
	[]);

	const handleChange = useCallback(function (e)
	{
		setNewValue(e.target.value);
	},
	[]);

	const saveChange = useCallback(function (e)
	{
		setEditing(false);
		_refs.current?.onChange?.(new_value);
	},
	[new_value]);

	const cancelEditing = useCallback(function (e)
	{
		setNewValue(EC_budget);
		setEditing(false);
	},
	[EC_budget]);

	const default_data = budget_options
	.find(opt => opt.value === EC_budget);

	return (
		<div className="c-dashboard__cell EC-renewal__budget-change">
			{
				editing ?
				(
					<>
						<Select name="new_value" value={ new_value }
							onChange={ handleChange }
							options={ available_options }
							bemit={ ['white-bg'] }
						/>

						<button type="button"
							className={ bemit('c-btn', ['v2', 'icon', 'green']) }
							onClick={ saveChange }>
							<FaCheck className="c-btn__icon" />
							Appliquer
						</button>

						<button type="button"
							className={ bemit('c-btn', ['v2', 'icon', 'red']) }
							onClick={ cancelEditing }>
							<FaArrowRotateLeft className="c-btn__icon" />
							Annuler
						</button>
					</>
				)
				:
				(
					<>
						{ default_data?.label }

						<button type="button"
							className={ bemit('c-btn', ['v2', 'icon']) }
							onClick={ startEditing }>
							<LuArrowUpDown className="c-btn__icon" />
							Changer de tranche
						</button>
					</>
				)
			}
		</div>
	);
}